import axios from "axios";

export const syncRegisterCompanyWithMatchUp = async (dataToSync) => (
  axios.post(
    `${process.env.REACT_APP_MATCHUP_BACKEND}api/public/sync/companyEmployee`,
    dataToSync,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
);
